var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-wrapper"},[(_vm.statusConfig)?_c('color-chip',{staticClass:"status-chip",attrs:{"label":_vm.statusConfig.label,"prefix-icon":_vm.statusConfig.icon,"icon-pack":_vm.statusConfig.iconPack,"variant":_vm.statusConfig.variant,"round":24}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }